import script from "./LikeIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LikeIcon.vue?vue&type=script&setup=true&lang=ts"

import "./LikeIcon.vue?vue&type=style&index=0&id=3cfdb45e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cfdb45e"]])

export default __exports__